import { Box, List, ListItem, Typography, Chip } from '@mui/material';
import { TwilioRegistrationRecord } from '../models';
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";

interface TwilioSessionsListProps {
  sessions: TwilioRegistrationRecord[];
  isLoading: boolean;
  currentUserId?: string;
}

export function TwilioSessionsList({ sessions, isLoading, currentUserId }: TwilioSessionsListProps) {
  return (
    <SpinnerWrapper loading={isLoading}>
      {(!sessions || sessions.length === 0) ? (
        <Box sx={styles.centerContent}>
          <Typography color="textSecondary">No active sessions</Typography>
        </Box>
      ) : (
        <List disablePadding>
          {sessions.map((session) => {
            const isCurrentUser = currentUserId && session.id === currentUserId;
            
            return (
              <ListItem 
                key={session.id} 
                divider 
                sx={{
                  ...styles.listItem,
                  ...(isCurrentUser && styles.currentUserItem)
                }}
              >
                <Box sx={styles.fullWidth}>
                  <Box sx={styles.headerRow}>
                    <Box sx={styles.nameContainer}>
                      <Typography variant="subtitle1">{session.fullName}</Typography>
                      {isCurrentUser && (
                        <Chip
                          label="Current"
                          size="small"
                          color="success"
                          sx={styles.currentChip}
                        />
                      )}
                    </Box>
                    <Box sx={styles.stepContainer}>
                        {session.duration && (
                           <Typography variant="caption" sx={styles.durationText}>
                             {session.duration}
                           </Typography>
                        )}
                        <Chip 
                          label={`Step ${session.currentStep}`} 
                          size="small" 
                          color="primary" 
                          variant="outlined" 
                        />
                    </Box>
                  </Box>
                  
                  <Typography variant="body2" sx={styles.stepDescription}>
                    {session.stepDescription}
                  </Typography>
                  
                  <Typography variant="body2" color="primary" sx={styles.statusText}>
                    {session.status}
                  </Typography>
                  
                  {session.errorMessage && (
                    <Typography variant="body2" color="error">
                      {session.errorMessage}
                    </Typography>
                  )}
                </Box>
              </ListItem>
            );
          })}
        </List>
      )}
    </SpinnerWrapper>
  );
}

const styles = {
  centerContent: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100%'
  },
  listItem: {
    padding: '12px 0'
  },
  fullWidth: {
    width: '100%'
  },
  headerRow: {
    display: 'flex', 
    justifyContent: 'space-between', 
    mb: 1
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  stepDescription: {
    fontWeight: 500,
    mb: 1
  },
  statusText: {
    mb: 1
  },
  currentUserItem: {
    backgroundColor: 'rgba(76, 175, 80, 0.08)'
  },
  currentChip: {
    height: '20px'
  },
  stepContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  durationText: {
    color: 'text.secondary',
    fontWeight: 500
  }
};
